/**
 * Central Mapping for Team Logos & Flags
 * Maps team names/codes (e.g., 'IND', 'India') to high-quality SVG/PNG icons.
 */

const TEAM_FLAGS = {
  // International Codes
  "IND": "https://img.icons8.com/color/96/india-circular.png",
  "AUS": "https://img.icons8.com/color/96/australia-circular.png",
  "PAK": "https://img.icons8.com/color/96/pakistan-circular.png",
  "ENG": "https://img.icons8.com/color/96/england-circular.png",
  "RSA": "https://img.icons8.com/color/96/south-africa-circular.png",
  "SA":  "https://img.icons8.com/color/96/south-africa-circular.png",
  "NZ":  "https://img.icons8.com/color/96/new-zealand-circular.png",
  "WI":  "https://img.icons8.com/color/96/west-indies-circular.png",
  "SL":  "https://img.icons8.com/color/96/sri-lanka-circular.png",
  "AFG": "https://img.icons8.com/color/96/afghanistan-circular.png",
  "BAN": "https://img.icons8.com/color/96/bangladesh-circular.png",
  "ZIM": "https://img.icons8.com/color/96/zimbabwe-circular.png",
  "IRE": "https://img.icons8.com/color/96/ireland-circular.png",
  "SCO": "https://img.icons8.com/color/96/scotland-circular.png",
  "NAM": "https://img.icons8.com/color/96/namibia-circular.png",
  "NEP": "https://img.icons8.com/color/96/nepal-circular.png",
  "UAE": "https://img.icons8.com/color/96/united-arab-emirates-circular.png",
  "USA": "https://img.icons8.com/color/96/usa-circular.png",

  // IPL Teams
  "CSK": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2b/Chennai_Super_Kings_Logo.svg/200px-Chennai_Super_Kings_Logo.svg.png",
  "MI":  "https://upload.wikimedia.org/wikipedia/en/thumb/c/cd/Mumbai_Indians_Logo.svg/200px-Mumbai_Indians_Logo.svg.png",
  "RCB": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2a/Royal_Challengers_Bangalore_Logo.svg/200px-Royal_Challengers_Bangalore_Logo.svg.png",
  "KKR": "https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Kolkata_Knight_Riders_Logo.svg/200px-Kolkata_Knight_Riders_Logo.svg.png",
  "SRH": "https://upload.wikimedia.org/wikipedia/en/thumb/8/81/Sunrisers_Hyderabad.svg/200px-Sunrisers_Hyderabad.svg.png",
  "DC":  "https://upload.wikimedia.org/wikipedia/en/thumb/2/2f/Delhi_Capitals_Logo.svg/200px-Delhi_Capitals_Logo.svg.png",
  "PBKS":"https://upload.wikimedia.org/wikipedia/en/thumb/d/d4/Punjab_Kings_Logo.svg/200px-Punjab_Kings_Logo.svg.png",
  "RR":  "https://upload.wikimedia.org/wikipedia/en/thumb/6/60/Rajasthan_Royals_Logo.svg/200px-Rajasthan_Royals_Logo.svg.png",
  "GT":  "https://upload.wikimedia.org/wikipedia/en/thumb/0/09/Gujarat_Titans_Logo.svg/200px-Gujarat_Titans_Logo.svg.png",
  "LSG": "https://upload.wikimedia.org/wikipedia/en/thumb/1/13/Lucknow_Super_Giants_Logo.svg/200px-Lucknow_Super_Giants_Logo.svg.png",
  "LSGK":"https://upload.wikimedia.org/wikipedia/en/thumb/1/13/Lucknow_Super_Giants_Logo.svg/200px-Lucknow_Super_Giants_Logo.svg.png",
  "PWI": "https://img.icons8.com/color/96/cricket.png",
  "GL":  "https://img.icons8.com/color/96/cricket.png",
  "KXIP":"https://upload.wikimedia.org/wikipedia/en/thumb/d/d4/Punjab_Kings_Logo.svg/200px-Punjab_Kings_Logo.svg.png",

  // Full Names Fallback
  "INDIA": "https://img.icons8.com/color/96/india-circular.png",
  "AUSTRALIA": "https://img.icons8.com/color/96/australia-circular.png",
  "PAKISTAN": "https://img.icons8.com/color/96/pakistan-circular.png",
  "ENGLAND": "https://img.icons8.com/color/96/england-circular.png",
  "CHENNAI SUPER KINGS": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2b/Chennai_Super_Kings_Logo.svg/200px-Chennai_Super_Kings_Logo.svg.png",
  "MUMBAI INDIANS": "https://upload.wikimedia.org/wikipedia/en/thumb/c/cd/Mumbai_Indians_Logo.svg/200px-Mumbai_Indians_Logo.svg.png",
  "ROYAL CHALLENGERS BENGALURU": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2a/Royal_Challengers_Bangalore_Logo.svg/200px-Royal_Challengers_Bangalore_Logo.svg.png",
  "KOLKATA KNIGHT RIDERS": "https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Kolkata_Knight_Riders_Logo.svg/200px-Kolkata_Knight_Riders_Logo.svg.png",
  "SUNRISERS HYDERABAD": "https://upload.wikimedia.org/wikipedia/en/thumb/8/81/Sunrisers_Hyderabad.svg/200px-Sunrisers_Hyderabad.svg.png",
  "DELHI CAPITALS": "https://upload.wikimedia.org/wikipedia/en/thumb/2/2f/Delhi_Capitals_Logo.svg/200px-Delhi_Capitals_Logo.svg.png",
  "PUNJAB KINGS": "https://upload.wikimedia.org/wikipedia/en/thumb/d/d4/Punjab_Kings_Logo.svg/200px-Punjab_Kings_Logo.svg.png",
  "RAJASTHAN ROYALS": "https://upload.wikimedia.org/wikipedia/en/thumb/6/60/Rajasthan_Royals_Logo.svg/200px-Rajasthan_Royals_Logo.svg.png",
  "GUJARAT TITANS": "https://upload.wikimedia.org/wikipedia/en/thumb/0/09/Gujarat_Titans_Logo.svg/200px-Gujarat_Titans_Logo.svg.png",
  "LUCKNOW SUPER GIANTS": "https://upload.wikimedia.org/wikipedia/en/thumb/1/13/Lucknow_Super_Giants_Logo.svg/200px-Lucknow_Super_Giants_Logo.svg.png",
};

export const getAssetURL = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  
  // Handle relative paths from backend
  const baseUrl = window.location.hostname === "localhost" 
    ? "http://localhost:5000" 
    : "https://backend-sjup.onrender.com";
    
  return `${baseUrl}/${path.startsWith("/") ? path.slice(1) : path}`;
};

export const getTeamLogo = (teamName, logoUrl = null) => {
  if (logoUrl) return getAssetURL(logoUrl);
  if (!teamName) return "https://img.icons8.com/color/96/cricket.png";
  
  const normalized = teamName.toUpperCase().trim();
  
  // Direct match
  if (TEAM_FLAGS[normalized]) return TEAM_FLAGS[normalized];

  // Word-boundary match to prevent 'IND' matching 'RAWALPINDIZ'
  const words = normalized.split(/[\s_-]+/);
  for (const [key, value] of Object.entries(TEAM_FLAGS)) {
    if (words.includes(key)) return value;
  }

  // Final fallback
  return "https://img.icons8.com/color/96/cricket.png";
};

export const TEAM_ASSETS = {
    DEFAULT_PLAYER: "https://img.icons8.com/color/96/cricket-player.png",
    DEFAULT_TEAM: "https://img.icons8.com/color/96/cricket.png"
};
